import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";

const AppleSuccess = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const run = async () => {
      const token = params.get("token");
      if (!token) {
        toast.error("Apple login failed (token missing)");
        navigate("/login");
        return;
      }

      localStorage.setItem("token", token);

      // ✅ fetch user (so your app recognizes session)
      const res = await fetch(`${process.env.REACT_APP_API_URL}/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!res.ok) {
        localStorage.removeItem("token");
        toast.error("Session setup failed");
        navigate("/login");
        return;
      }

      const data = await res.json();
      localStorage.setItem("user", JSON.stringify(data.user));

      toast.success("Logged in with Apple");
      navigate("/");
    };

    run();
  }, [params, navigate]);

  return null;
};

export default AppleSuccess;
